import { jsx as _jsx } from "react/jsx-runtime";
import { WalletExecutionTransition } from '../../Withdraw/Presentation/WalletExecutionTransition';
/** Exchange the address instructions for progress without snapping the form height. */
export function DepositAddressTransition({ instructions, processing, summary, }) {
    return (_jsx(WalletExecutionTransition, { gap: 12, overview: summary, controls: instructions, workflow: processing }));
}
